import React from 'react';
import { Icon } from '@lqa-frontend/ui-system';
import type { IconName } from '@lqa-frontend/ui-system';
import { cn } from '../../lib/utils';
import { OrderBy } from './types';
import type { ITableSortState } from './types';

interface ITableSortIconProps {
	sortField: string;
	sort: ITableSortState;
	className?: string;
}

function getTableSortIconName(
	sortField: string,
	sort: ITableSortState
): IconName {
	const isActive = sort.field === sortField;

	if (!isActive) {
		return 'arrowDownUp';
	}

	if (sort.order === OrderBy.ASC) {
		return 'sortAppliedAsc';
	}

	return 'sortAppliedDesc';
}

/**
 * The icons render with `currentColor`, so the applied/possible distinction
 * comes from here rather than from a fill baked into the SVG asset.
 */
function getTableSortIconColor(
	sortField: string,
	sort: ITableSortState
): string {
	return sort.field === sortField ? 'text-interactive' : 'text-brand-blue-400';
}

function TableSortIcon({
	sortField,
	sort,
	className,
}: Readonly<ITableSortIconProps>) {
	return (
		<Icon
			name={getTableSortIconName(sortField, sort)}
			data-testid="tableSortIcon-icon"
			className={cn(getTableSortIconColor(sortField, sort), className)}
		/>
	);
}

export { TableSortIcon, getTableSortIconName };
export type { ITableSortIconProps };
